import React from "react";
import {
	string,
	oneOfType,
	number,
	objectOf,
	object,
	shape,
	array,
	oneOf,
	func,
	bool,
} from "prop-types";
import cx from "classnames";
import { Link } from "gatsby";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// import { Icon } from "../../../Icons";
import * as styles from "./MobileCard.module.scss";
// TODO:: CardLink used by other cards. Move it to sharedComponents/card
const MobileCardLink = ({ link, text, className, rel }) => (
	<Link to={link} className={className} rel={rel}>
		<span className="sr-only">{text}</span>
	</Link>
);

const MobileCard = ({
	image,
	header,
	content,
	button,
	link,
	// linkIcon,
	className,
	imageClassName,
	style,
	headerClassName,
	color,
	slot,
	variant,
	primary,
}) => (
	<div className={cx(className)}>
		<Card
			className={cx(
				styles.hero,
				slot && styles.slot,
				variant && styles[variant],
				primary && styles.primary,
				image && (header || link?.text) && styles.flex
			)}
			style={{
				...style,
				backgroundColor: !primary && color,
				color: primary && color,
			}}>
			<div className={cx(styles.image, imageClassName)}>
				<Card.Image
					src={!image.srcSet && image.src}
					source={image.srcSet && image}
					fluid={image.fluid}
					alt={image.alt}
					cloudinary={image.cloudinary}
					className={cx(styles.imageWrapper)}
				/>
				{link?.to && (
					<MobileCardLink
						link={link.to}
						text={header || link?.text}
						className={cx(styles.heroLink)}
					/>
				)}
				{button?.to && (
					<MobileCardLink link={button.to} text={button.text} className={cx(styles.heroLink)} />
				)}
			</div>
			{header || link?.text ? (
				<Card.BodyContainer
					className={cx(styles.contentContainer, headerClassName)}
					style={{
						backgroundColor: !primary && color,
					}}>
					{header && (
						<div>
							<Card.Header className={cx(styles.heading)}>
								<div className={cx(styles.headingContainer)}>{header}</div>
							</Card.Header>
						</div>
					)}
					{content && <Card.Content>{content}</Card.Content>}
					{button && (
						<Card.Button
							to={button.to}
							className={cx(styles.btn, styles[button?.variant])}
							variant={button?.variant}>
							{button.text}
						</Card.Button>
					)}
					{link?.to && (
						<Card.Link to={link.to} className={cx(styles.link)}>
							<div className={cx(styles.linkText)}>
								{/* {linkIcon && <Icon name={linkIcon} className={`swg-text-lg ${cx(styles.icon)}`} />} */}
								{link.text}
							</div>
						</Card.Link>
					)}
				</Card.BodyContainer>
			) : (
				<></>
			)}
		</Card>
	</div>
);

MobileCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
		cloudinary: shape({
			publicId: string,
			width: number,
			height: number,
			rawTransformation: string,
			version: number,
			aspectRatio: number,
			adoptHeight: bool,
		}),
	}).isRequired,
	header: string,
	headerClassName: string,
	imageClassName: string,

	content: string,
	button: shape({
		icon: string,
		iconPlacement: oneOf(["right", "left"]),
		onClick: func,
		label: string,
	}),
	// linkIcon: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: string,
		text: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
	color: string,
	slot: bool,
	variant: string,
	primary: bool,
};

MobileCard.defaultProps = {
	header: "",
	headerClassName: "",
	imageClassName: "",

	content: "",
	button: null,
	// linkIcon: null,
	link: null,
	className: "",
	style: {},
	color: null,
	slot: false,
	variant: null,
	primary: false,
};

MobileCardLink.propTypes = {
	link: string,
	text: string,
	className: string,
	rel: string,
};

MobileCardLink.defaultProps = {
	link: null,
	text: null,
	className: null,
	rel: "",
};

export default MobileCard;
export { MobileCard, MobileCardLink };
